import * as React from 'react'

import { Instrument } from '../../../../main/types'
import TilesStore from '../../../futures/stores/tilesStore'
import { cryptoDomains, generateColorScale } from '../../../futures/utils'
import { decodeQueryString, encodeQueryString } from '../../../queryString'
import ForexCryptoTile from '../../../shared/components/ForexCryptoTile'
import { redGreenGradient } from '../../../shared/gradients'
import * as hoverChart from '../../../shared/hover-chart'

interface TileProps {
  ticker: string
  hoverOffsetX: number
  hoverOffsetY: number
}

const getTileState = (ticker: string) => {
  var tile = TilesStore.getTile(ticker)

  return {
    ...tile,
  }
}

const colorScale = generateColorScale(cryptoDomains, 'd', redGreenGradient)

export default class Tile extends React.Component<TileProps> {
  state = getTileState(this.props.ticker)

  componentDidMount() {
    TilesStore.addChangeListener(this._onChange)
  }

  componentWillUnmount() {
    TilesStore.removeChangeListener(this._onChange)
  }

  _onChange = () => {
    this.setState(getTileState(this.props.ticker))
  }

  render() {
    var queryString = decodeQueryString()
    var { label, last, prevClose, change, high, low, sparkline, sparklineDateChanges } = this.state
    var { ticker, hoverOffsetX, hoverOffsetY } = this.props
    var format = (n: number) => (n >= 0 ? '+' : '') + n.toFixed(2) + '%'
    var places = last > 6 ? 2 : 4
    if (last < 0.001 && last > 0) {
      places = last < 0.0001 ? 8 : 7
    }

    var round = (n: number) => (+(Math.round(Number(n + 'e+' + places)) + 'e-' + places)).toFixed(places)
    var range = (high - low) * 0.1
    var highlightHigh = last > high - range
    var highlightLow = last < low + range
    let lastChange = round(last - prevClose)

    if (lastChange === 'NaN') {
      lastChange = (last - prevClose).toFixed(places)
    }

    const instrument = ticker === 'EURUSD' ? Instrument.Forex : Instrument.Crypto
    const link =
      instrument === Instrument.Crypto
        ? `/crypto_charts.ashx?` + encodeQueryString({ ...queryString, p: 'd1', t: ticker })
        : '/forex_charts.ashx?p=d1&t=' + ticker

    const chartImage = hoverChart.getHoverChartImg(
      '@' + ticker.toLowerCase(),
      false,
      Instrument.Crypto ? FinvizSettings.hoverCharts?.crypto?.timeframe : FinvizSettings.hoverCharts?.forex?.timeframe,
      Instrument.Crypto ? FinvizSettings.hoverCharts?.crypto?.dateRange : FinvizSettings.hoverCharts?.forex?.dateRange
    )

    const boxover = `cssbody=[hoverchart] cssheader=[tabchrthdr] body=[${chartImage.img}] offsetx=[${hoverOffsetX}] offsety=[${hoverOffsetY}] delay=[100]`

    return (
      <ForexCryptoTile
        boxover={boxover}
        link={link}
        last={round(last)}
        high={round(high)}
        low={round(low)}
        label={label}
        sparkline={sparkline}
        sparklineDateChanges={sparklineDateChanges}
        change={format(change)}
        sparklineChange={change}
        lastChange={lastChange}
        backgroundColor={colorScale(change)}
        highlightHigh={highlightHigh}
        highlightLow={highlightLow}
      />
    )
  }
}
